export default __webpack_public_path__ + "static/media/scrumAuditor_icon.9d5b4a82.webp";